const fonts = {
  oxanium: "Oxanium, Oxanium, sans-serif"
};

export default fonts;
